import { z } from 'zod';

export const ProblemErrorItem = z.object({
  path: z.string(),
  code: z.string(),
  message: z.string(),
});
export type ProblemErrorItem = z.infer<typeof ProblemErrorItem>;

export const Problem = z.object({
  type: z
    .string()
    .url()
    .or(z.string().regex(/^[a-z][a-z0-9_-]*$/)),
  title: z.string(),
  status: z.number().int().min(400).max(599),
  detail: z.string().optional(),
  instance: z.string().optional(),
  requestId: z.string().optional(),
  errors: z.array(ProblemErrorItem).optional(),
});
export type Problem = z.infer<typeof Problem>;

export const PROBLEM_TYPES = {
  validation: 'https://errors.iq-print-guard.local/validation',
  unauthorized: 'https://errors.iq-print-guard.local/unauthorized',
  forbidden: 'https://errors.iq-print-guard.local/forbidden',
  notFound: 'https://errors.iq-print-guard.local/not-found',
  conflict: 'https://errors.iq-print-guard.local/conflict',
  rateLimit: 'https://errors.iq-print-guard.local/rate-limit',
  unprocessable: 'https://errors.iq-print-guard.local/unprocessable',
  notAcceptable: 'https://errors.iq-print-guard.local/not-acceptable',
  upstreamUnavailable: 'https://errors.iq-print-guard.local/upstream-unavailable',
  internal: 'https://errors.iq-print-guard.local/internal',
} as const;
export type ProblemType = (typeof PROBLEM_TYPES)[keyof typeof PROBLEM_TYPES];
